import React from 'react';
import PropTypes from 'prop-types';
import { convertColorToThemeHexCode } from 'Styles/colors.util';

import * as Styled from './Puck.styled';

/**
 * a Puck displays a count on top of a hexagon shape
 */
const Puck = ({ fill, count, ...props }) => (
  <Styled.Puck {...props}>
    <Styled.Hexagon $fill={fill} />
    <Styled.Count data-testid="Puck__count">{count}</Styled.Count>
  </Styled.Puck>
);

Puck.propTypes = {
  /**
   * Color of the hexagon
   */
  fill: PropTypes.string,
  /**
   * Number to display
   */
  count: PropTypes.number.isRequired
};

Puck.defaultProps = {
  fill: convertColorToThemeHexCode('blue')
};

export default Puck;
